/**
 * "Gestionar miembros" de una base (tipo 'aplicacion') o de una tabla ('tabla').
 * Ver extras_mg/api/roles/views.py.
 */
export default (client) => ({
  obtener(tipo, id) {
    return client.get(`/extras-mg/roles/${tipo}/${id}/`)
  },
  asignar(tipo, id, usuarioId, rol) {
    return client.put(`/extras-mg/roles/${tipo}/${id}/`, {
      usuario_id: usuarioId,
      rol,
    })
  },
  invitar(tipo, id, correo, rol, urlBase) {
    return client.post(`/extras-mg/roles/${tipo}/${id}/invitar/`, {
      correo,
      rol,
      url_base: urlBase,
    })
  },
  cancelarPendiente(id) {
    return client.delete(`/extras-mg/roles/pendiente/${id}/`)
  },
})
